module.exports = __webpack_public_path__ + "img/room-creative-award_zh.cc50fe2c.png";